import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../../components/ui/alert-dialog";
import { Button } from "../../components/ui/button";

export const BulkVisibilityBar = ({ selected, hiddenCount, onApply, onClear }) => {
  const [action, setAction] = useState(null); // null | "show" | "hide"
  const n = selected.length;
  if (!n) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 mb-4 rounded-2xl bg-[#59394F] text-white px-5 py-3" data-testid="bulk-bar">
      <span className="text-sm" data-testid="bulk-count">{n} research product{n > 1 ? "s" : ""} selected{hiddenCount > 0 ? ` (${hiddenCount} not shown by current filters)` : ""}</span>
      <Button size="sm" onClick={() => setAction("show")} className="rounded-full bg-[#A8B59A] hover:bg-[#8F9C82] text-[#2B3024]" data-testid="bulk-show">Show on store</Button>
      <Button size="sm" onClick={() => setAction("hide")} className="rounded-full bg-white text-[#5A433B] hover:bg-white/90" data-testid="bulk-hide">Hide from store</Button>
      <button onClick={onClear} className="text-xs underline ml-auto" data-testid="bulk-clear">Clear selection</button>
      <AlertDialog open={!!action} onOpenChange={(o) => { if (!o) setAction(null); }}>
        <AlertDialogContent data-testid="bulk-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{action === "show" ? `Show ${n} product${n > 1 ? "s" : ""} on the store?` : `Hide ${n} product${n > 1 ? "s" : ""} from the store?`}</AlertDialogTitle>
            <AlertDialogDescription>
              {action === "show"
                ? "Customers will be able to see and order these research products. Skincare serums are never included."
                : "Customers will no longer see or be able to order these research products."}
              <span className="block mt-3 text-xs text-[#5A433B]">{selected.map((p) => p.name).join(", ")}</span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="bulk-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => onApply(action === "hide")} data-testid="bulk-confirm">
              {action === "show" ? "Yes, show them" : "Yes, hide them"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
